import React, { useState, useRef, useEffect } from 'react';
import './App.css';
import Canvas from './Canvas';
import { palettes } from './Palettes';

function App() {
  const [selectedPalette, setSelectedPalette] = useState(palettes[0]);
  const canvasRef = useRef(null);

  const [, setWindowSize] = useState({ width: window.innerWidth, height: window.innerHeight });
  useEffect(() => {
    const handleResize = () => setWindowSize({ width: window.innerWidth, height: window.innerHeight });
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="App">
      <Canvas 
        ref={canvasRef} 
        selectedPalette={selectedPalette} 
        onPaletteChange={setSelectedPalette} 
      />
    </div>
  );
}

export default App;
